// src/components/PrivateRoute.jsx
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { usePermisos } from "../context/PermisosContext";
import { clearSession, isTokenExpired } from "../services/sessionUtils";
import { isSuperAdmin } from "../services/authUtils";

import { BITSET_LEN } from "../constants/permisos";
const MIN_BITSET = "1" + "0".repeat(BITSET_LEN - 1);

function sanitize(s = "") {
  const raw = (s || "").toString().padEnd(BITSET_LEN, "0").slice(0, BITSET_LEN);
  return "1" + raw.slice(1); // fuerza bit #1 = 1
}
function hasBit(bitset = "", oneBasedPos) {
  if (typeof oneBasedPos !== "number") return false;
  const i = oneBasedPos - 1;
  return i >= 0 && i < bitset.length && bitset[i] === "1";
}
function ExpiredRedirect() {
  useEffect(() => clearSession(), []);
  return <Navigate to="/?sesion=expirada" replace />;
}

export default function PrivateRoute({ requireBits = [], superAdminOnly = false, children }) {
  // Hook SIEMPRE al comienzo
  const { bitset, loading } = usePermisos();

  // Token: si no hay, afuera
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/" replace />;
  if (isTokenExpired(token)) {
    return <ExpiredRedirect />;
  }
  if (superAdminOnly && !isSuperAdmin()) return <Navigate to="/dashboard/admin" replace />;

  // Mientras carga, no redirigimos aún
  if (loading) {
    return (
      <div className="min-h-dvh grid place-items-center bg-black text-white">
        <div className="text-center">
          <div className="animate-pulse text-lg">Cargando permisos…</div>
        </div>
      </div>
    );
  }

  // ✅ Preferimos SIEMPRE el endpoint de localStorage (más reciente),
  //    luego el del contexto, y lo sanitizamos para garantizar bit #1.
  const effective = sanitize(
    localStorage.getItem("endpoint") || bitset || MIN_BITSET
  );

  if (!requireBits || requireBits.length === 0) return children;

  const allowed = requireBits.every((pos) => hasBit(effective, pos));
  return allowed ? children : <Navigate to="/" replace />;
}
